export default __webpack_public_path__ + "static/media/28-tired-face_1f62b.7b69a063.png";